/* Sewari: estrellas -> reseñas, "Dejar mi reseña" y "Preguntas frecuentes" en páginas de producto */
(function () {
  function ready(fn) { document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }
  function offset() { var h = document.querySelector('#header-group'); return (h ? h.getBoundingClientRect().height : 0) + 16; }
  function goSettled(el) { go(el); var n = 0; (function chk() { if (n++ > 5) return; setTimeout(function () { if (Math.abs(el.getBoundingClientRect().top - offset()) > 30) go(el); chk(); }, 800); })(); }
  function go(el) { if (!el) return; var y = el.getBoundingClientRect().top + window.pageYOffset - offset(); window.scrollTo({ top: y, behavior: 'smooth' }); }
  function findFaq() {
    var all = document.querySelectorAll('[class*="ai-faq-"]');
    for (var i = 0; i < all.length; i++) { if (/(^|\s)ai-faq-[a-z0-9]+(\s|$)/.test(all[i].className)) return all[i].closest('.shopify-section') || all[i]; }
    return document.querySelector('.shopify-section [id*="faq" i], .shopify-section[id*="faq" i]');
  }
  function link(txt, cls, fn) {
    var a = document.createElement('a'); a.href = '#'; a.textContent = txt; a.className = 'sw-rf__link ' + cls;
    a.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); fn(); }); return a;
  }
  function sep() { var s = document.createElement('span'); s.className = 'sw-rf__sep'; s.textContent = '|'; s.setAttribute('aria-hidden', 'true'); return s; }
  ready(function () {
    if (document.querySelector('.sw-rf')) return;
    var scope = document.querySelector('[id$="__product-information"]') || document;
    var reviews = document.getElementById('judgeme_product_reviews') || document.querySelector('.jdgm-review-widget');
    var faq = findFaq();
    var st = document.createElement('style');
    st.textContent = '.sw-rf{display:inline-flex;align-items:center;flex-wrap:wrap;gap:8px;font-size:13px;line-height:1.4;margin:4px 0}' +
      '.sw-rf__link{color:#ff4b4b!important;text-decoration:underline;text-underline-offset:3px;cursor:pointer}' +
      '.sw-rf__sep{color:#ff4b4b;opacity:.6}.sw-rf-stars{cursor:pointer}.sw-rf-wrap{flex-wrap:wrap;gap:8px}';
    document.head.appendChild(st);
    var box = document.createElement('span'); box.className = 'sw-rf';
    var rating = scope.querySelector('.rating-wrapper');
    if (rating) {
      rating.classList.add('sw-rf-stars', 'sw-rf-wrap');
      rating.setAttribute('role', 'link'); rating.setAttribute('tabindex', '0'); rating.title = 'Ver reseñas';
      var toRev = function () { go(reviews); };
      rating.addEventListener('click', function (e) { if (e.target.closest('.sw-rf')) return; toRev(); });
      rating.addEventListener('keydown', function (e) { if (e.key === 'Enter') toRev(); });
    } else if (reviews) {
      box.appendChild(link('Dejar mi reseña', 'sw-rf__write', function () {
        go(reviews);
        setTimeout(function () { var w = reviews.querySelector('.jdgm-write-rev-link'); if (w) w.click(); }, 600);
      }));
    }
    if (reviews) { if (box.childNodes.length || rating) box.appendChild(sep()); box.appendChild(link('Reseñas ↓', 'sw-rf__rev', function () { goSettled(reviews); })); }
    if (faq) {
      if (box.childNodes.length || rating) box.appendChild(sep());
      box.appendChild(link('Preguntas frecuentes', 'sw-rf__faq', function () { go(faq); }));
    }
    if (!box.childNodes.length) return;
    if (rating) { rating.appendChild(box); }
    else {
      var price = scope.querySelector('product-price') || scope.querySelector('.price');
      if (!price) return;
      var row = document.createElement('div'); row.appendChild(box);
      price.insertAdjacentElement('afterend', row);
    }
  });
})();